import { JDSMenuBlockInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSMenuBlockInternalProps>
  ): React.FC<JDSMenuBlockInternalProps> =>
  (props: JDSMenuBlockInternalProps) => {
    return <Component {...props} />;
  };
